import React, { useState } from "react";

import { Box, Divider, Typography } from "@mui/material";

import {
  dateToString,
  getCarName,
  getUserName,
  parseRFC3339,
} from "data/functions";
import {
  isObjectEmpty,
  translateOrderStatus,
  translateOrderType,
} from "data/functions";
import { constants } from "data/globals";

export function ParamRow(props) {
  return (
    <React.Fragment>
      <Box
        sx={{
          alignItems: "flex-end",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          margin: "8px 0 0",
          width: "100%",
        }}
      >
        <Typography>{props?.title}</Typography>
        <Box
          sx={{
            fontSize: "1rem",
            fontWeight: "400",
            letterSpacing: "0.00938em",
            lineHeight: "1.5",
          }}
        >
          {props?.subTitle}
        </Box>
      </Box>
      <Divider />
    </React.Fragment>
  );
}

export function OrderParams({ department, docItem }) {
  return (
    <React.Fragment>
      {translateOrderType(docItem?.type) !== constants.ruTypeZR &&
        docItem?.status && (
          <ParamRow
            subTitle={translateOrderStatus(docItem?.status)}
            title="Статус"
          />
        )}
      {docItem?.user && getUserName(docItem?.user?.name) && (
        <ParamRow subTitle={getUserName(docItem?.user?.name)} title="Клиент" />
      )}
      {/* {department?.name && (
        <ParamRow subTitle={department?.name} title="Филиал" />
      )} */}
      {department?.adress && (
        <ParamRow
          subTitle={
            department?.region &&
            !department?.adress.includes(department?.region)
              ? department?.region + ", " + department?.adress
              : department?.adress
          }
          title="Адрес"
        />
      )}

      {/* {docItem?.masterName && (
            <ParamRow subTitle={docItem?.masterName} title="Мастер" />
          )} */}

      {!isObjectEmpty(getCarName(docItem, [], "", false)) && (
        <ParamRow
          subTitle={
            <Box
              sx={{ display: "flex", flexDirection: "row", flexWrap: "nowrap" }}
            >
              {docItem?.car?.marka?.imageUrl ? (
                <img
                  alt={"Марка"}
                  loading="lazy"
                  onError={(e) => {
                    // e.target.hidden = true;
                  }}
                  src={docItem?.car?.marka?.imageUrl}
                  style={{
                    height: "24px",
                    margin: "0 0 0 -2px",
                    overflow: "hidden",
                  }}
                />
              ) : undefined}

              {getCarName(docItem, [], "", false)}
            </Box>
          }
          title="Автомобиль"
        />
      )}
      {(docItem?.mileage || docItem?.mileage > 0) && (
        <ParamRow
          subTitle={docItem?.mileage + " км"}
          title="Зафиксированный пробег"
        />
      )}

      {(docItem?.payPaid || docItem?.payPaid > 0) && (
        <ParamRow
          subTitle={
            docItem?.payPaid +
            (docItem?.currencyName ? " " + docItem?.currencyName : " руб.")
          }
          title="Внесенный аванс"
        />
      )}
      {(docItem?.payCredits || docItem?.payCredits > 0) && (
        <ParamRow
          subTitle={docItem?.payCredits + " баллов."}
          title="Использованные баллы"
        />
      )}

      {!isObjectEmpty(parseRFC3339(docItem?.planDate)) && (
        <React.Fragment>
          {translateOrderType(docItem?.type) === constants.ruTypeZN && (
            <ParamRow
              subTitle={dateToString(parseRFC3339(docItem?.planDate), true)}
              title={"Время выдачи"}
            />
          )}
          {translateOrderType(docItem?.type) === constants.ruTypeZP && (
            <ParamRow
              subTitle={dateToString(parseRFC3339(docItem?.planDate), false)}
              title={"Срок поставки"}
            />
          )}
          {translateOrderType(docItem?.type) === constants.ruTypeZR && (
            <ParamRow
              subTitle={dateToString(
                parseRFC3339(docItem?.planDate),
                false,
                true
              )}
              title={"Время"}
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
